var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "autocomplete-many" },
    [
      _c("v-autocomplete", {
        staticClass: "new-ux small-close flex-grow-1",
        staticStyle: { "margin-top": "6px" },
        attrs: {
          value: _vm.selectedFormatted,
          items: _vm.allItems,
          "item-value": _vm.id,
          "item-text": _vm.text,
          label: _vm.label,
          placeholder: _vm.normalizedPlaceholder,
          outlined: "",
          multiple: _vm.multiple,
          "hide-details": !_vm.showDetails,
          clearable: "",
          disabled: _vm.disabledProps || _vm.loadingProps,
          loading: _vm.loading || _vm.loadingProps,
          rules: _vm.rules
        },
        on: { change: _vm.updateData },
        scopedSlots: _vm._u(
          [
            _vm.multiple
              ? {
                  key: "selection",
                  fn: function(data) {
                    return [
                      data.index < _vm.selectedItemsToShow
                        ? _c(
                            "v-chip",
                            _vm._b(
                              {
                                attrs: {
                                  "input-value": data.selected,
                                  close: _vm.multiple,
                                  small: ""
                                },
                                on: {
                                  click: data.select,
                                  "click:close": function($event) {
                                    return _vm.remover(
                                      data.item[_vm.id] || data.item
                                    )
                                  }
                                }
                              },
                              "v-chip",
                              data.attrs,
                              false
                            ),
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "truncate text-xs",
                                  style: {
                                    width:
                                      _vm.selected.length > 1 ? "50px" : "75px"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(data.item[_vm.text] || data.item) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      data.index === _vm.selectedItemsToShow
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "autocomplete-many-more",
                              attrs: { "x-small": "" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "text-xxs font-bold" },
                                [
                                  _vm._v(
                                    " + " +
                                      _vm._s(
                                        _vm.selected.length -
                                          _vm.selectedItemsToShow
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  }
                }
              : null
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }